import React, { useEffect, useRef, useState } from "react";
import "./AiLoader.scss";
import { useTranslation } from "@me8eon/translation";
import { Skeleton } from "./Skeleton";
import { Icon } from "@me8eon/icons";

interface AIStatusProps {
    visible?: boolean;
    autoStart?: boolean;
}

export const AiLoader: React.FC<AIStatusProps> = ({
    visible = true,
    autoStart = true,
}) => {
    const [stageIndex, setStageIndex] = useState<number>(0);

    const t = useTranslation();

    const stages: string[] = [
        t("ailoader.thinking"),
        t("ailoader.reading"),
        t("ailoader.processing"),
        t("ailoader.analysing"),
        t("ailoader.preparing"),
        t("ailoader.working")
    ];

    useEffect(() => {
        if (!autoStart || !visible) return;

        setStageIndex(0);

        let timeoutId: number;

        const runStage = (index: number) => {
            const isAnalysing = index === 3; // analysing index
            const delay = isAnalysing ? 5000 : 3000;

            timeoutId = window.setTimeout(() => {
                if (index < stages.length - 1) {
                    setStageIndex(index + 1);
                    runStage(index + 1);
                }
            }, delay);
        };

        runStage(0);

        return () => {
            clearTimeout(timeoutId);
        };
    }, [autoStart, visible]);

    if (!visible) return null;

    return (
        <div className="ai-status-container" id="aiStatus">
            <div className="ai-flex-wrapper">
                <div className="ai-icon">
                    <Icon name="aiLogoAnimate" />
                </div>
                <div className="ai-text">
                    <div key={stageIndex} className="ai-stage">
                        {stages[stageIndex]}{stageIndex !== 5 && "..."}
                    </div>
                </div>
            </div>
            <div className="loading-bar"></div>
            {stageIndex > 1 && (
                <Skeleton />
            )}
        </div>
    );
};
